import React from "react";
import "./ReadingListAll.css";
import { MdOutlineBookmarkAdd, MdMoreHoriz, savedToList } from "react-icons/md";
import ReadingListItem from "./ReadingListItem";
import RightFixed from "../../RightFixed/RightFixed";


export default function ReadingListAll({ saved, setSavedToList, savedToList }) {
  return (
    <div className="reading-all">
      <div className="bosh-container">
        <div className="reading-in">
          <div className="avatar-reading">
            <div className="ava-pic">S</div>
            <div className="person-info">
              <h4>Shaxzod Muradov</h4>
              <p>
                May 30 <span>2stories</span>
              </p>
            </div>
          </div>
          <div>
            <MdMoreHoriz className="more" />
          </div>
        </div>
        <h1 className="reading-h1">Reading List</h1>
        <ul className="reading-ul">
          {savedToList.map((item, i) => {
            return (
              <ReadingListItem
                key={i}
                savedToList={savedToList}
                setSavedToList={setSavedToList}
                item={item}
              />
            );
          })}
        </ul>
      </div>

      <div className="fix-div">
        <RightFixed />
      </div>
    </div>
  );
}
